import { call, put } from 'redux-saga/effects'
import { AuthActions } from '../reducers/AuthRedux'

export function* check(api) {
  try {
    const response = yield call(api.check)
    yield put(AuthActions.loginSuccess(response.user))
  } catch (err) {
  } finally {
    yield put(AuthActions.checkFinished())
  }
}

export function* login(api, { payload }) {
  try {
    const response = yield call(api.login, payload)
    yield put(AuthActions.loginSuccess(response.user))
  } catch (err) {
    yield put(AuthActions.loginFailure(err.message))
  }
}

export function* logout(api) {
  try {
    yield call(api.logout)
    yield put(AuthActions.logoutSuccess())
  } catch (err) {
    yield put(AuthActions.logoutFailure(err.message))
  }
}
